import React from "react"
import PropTypes from "prop-types"

import "./index.less"
import { Checkbox, Popover } from "antd"
import { QuestionIcon } from "../../../../icons/svg/iconQuestion"
import { TYPE_QUESTION, TYPE_SURVEY } from "../../../../utils/constants"

export function CheckboxEngagement(props) {
  const contentEngagement = () => (
    <div style={{ maxWidth: 300, fontSize: 12, textAlign: "justify" }}>
      Las preguntas de <span style={{ fontWeight: 600 }}>Engagement</span>{" "}
      permiten medir directamente el nivel de compromiso de los colaboradores
      con la organización. Por ello, su resultado no es considerado para el
      Clima Laboral, sino que se calcula de manera separada para obtener el
      nivel de Engagement como un indicador independiente.
    </div>
  )
  if (
    !(
      props.idQuestionType !== TYPE_QUESTION.qualitative &&
      props.surveyData.id_survey_type !== TYPE_SURVEY.leadership.idSurveyType &&
      !props.generic
    )
  ) {
    return null
  }
  return (
    <div className="EngagementCheck">
      <Checkbox
        checked={props.engagementCheck}
        disabled={props.generic || props.surveyData.measures?.length > 0}
        onChange={(e) => props.onChangeEngagementCheck(e.target.checked)}>
        <div className="EngagementCheck__Content">
          <span>Pregunta de Engagement</span>
          <Popover placement="rightBottom" content={contentEngagement}>
            <QuestionIcon style={{ marginLeft: 8 }} />
          </Popover>
        </div>
      </Checkbox>
    </div>
  )
}

CheckboxEngagement.propTypes = {
  isCreate: PropTypes.bool,
  surveyData: PropTypes.object,
  engagementCheck: PropTypes.bool,
  onChangeEngagementCheck: PropTypes.func,
  generic: PropTypes.bool,
  idQuestionType: PropTypes.number,
}

export default CheckboxEngagement
